import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../static/styles/EditProfile.module.css';
import { getUserProfile, updateUserProfile } from '../api/profile';
import dummyAvatar from '../static/img/Sidebar/Avatar.png';
import MessagePopup from '../components/MessagePopup';
import { trackProfileUpdate } from '../utils/analytics';
import ArrowLeft from '../static/img/backArrow.png'

const EditProfile = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [gender, setGender] = useState("");
  const [bio, setBio] = useState("");
  const [profileImage, setProfileImage] = useState(dummyAvatar);
  const [stats, setStats] = useState({
    tournaments: 0,
    completedTasks: 0,
    credits: 0,
    redeemedItems: 0
  });

  const [loading, setLoading] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Edit Profile | Jazz ESL";
    fetchUserProfile();
  }, []);

  const fetchUserProfile = async () => {
    try {
      const response = await getUserProfile();
      if (response.success) {
        setUsername(response.username || "");
        setEmail(response.email || "");
        setGender(response.gender?.toLowerCase() || "");
        setBio(response.bio || "");
        setDateOfBirth(
          response.dateOfBirth
            ? response.dateOfBirth.split("-").reverse().join("-")
            : ""
        );
        setProfileImage(response.profileImage || dummyAvatar);
        setStats({
          tournaments: response.total_tournament || 0,
          completedTasks: response.completed_tasks_total || 0,
          credits: response.credits || 0,
          redeemedItems: response.items_redeemed || 0
        });
      }
    } catch (error) {
    }
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!file.type.startsWith("image/")) {
        alert("Please select a valid image file.");
        return;
      }
      if (file.size > 2 * 1024 * 1024) { // 2MB limit
        alert("File size must not exceed 2MB.");
        return;
      }
      const reader = new FileReader();
      reader.onload = () => setProfileImage(reader.result); // Store Base64 string in profileImage
      reader.readAsDataURL(file);
    }
  };

  const handleSave = async () => {
    setLoading(true); // Start loading
    try {
      const profileData = {
        username,
        email,
        gender,
        bio,
        dateOfBirth,
        image: profileImage // Include Base64 string in the payload
      };

      const response = await updateUserProfile(profileData);

      if (response.status) {
        trackProfileUpdate(true);
        setPopupMessage("Profile updated successfully!");
        setIsPopupOpen(true);
        await fetchUserProfile();
      } else {
        trackProfileUpdate(false);
        setPopupMessage(`Failed to update profile: ${response.message}`);
        setIsPopupOpen(true);
      }
    } catch (error) {
      setPopupMessage("An error occurred while updating the profile.");
      setIsPopupOpen(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.navigationHeader}>
        <div
          className={styles.navigationBack}
          onClick={() => navigate(-1)}
        >
          <img src={ArrowLeft} alt="<" />
        </div>
        <div className={styles.navigationTitle}>
          <p>user</p>
          <h2 className={styles.heading}>Edit profile</h2>
        </div>
      </div>

      <div className={styles.editProfile}>
        <div className={styles.gamingTaskHeader}>
          <div className={styles.avatarCircle}>
            <label htmlFor="imageUpload">
              <img src={profileImage} alt="Profile" className={styles.profileImage} />
            </label>
            <input
              id="imageUpload"
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={handleImageChange}
            />
            <div className={styles.avatarInfo}>
              <p className={styles.subheading}>hello</p>
              <h2 className={styles.heading}>{username ? username : 'Guest_user'}</h2>
            </div>
            
          </div>
          
          <div className={styles.headerstatsContainer}>
            <div className={styles.headerstats}>
              <span>{stats.tournaments}</span>
              <p>Tournaments Played</p>
            </div>
            <div className={styles.headerstats}>
              <span>{stats.completedTasks}</span>
              <p>Tasks Completed</p>
            </div>
            <div className={styles.headerstats}>
              <span>{stats.credits}</span>
              <p>Credits</p>
            </div>
            <div className={styles.headerstats}>
              <span>{stats.redeemedItems}</span>
              <p>Items Redemptions</p>
            </div>
          </div>
        </div>

        <div className={styles.formContainer}>
          <div className={styles.formGroup}>
            <label>Username</label>
            <input value={username} onChange={e => setUsername(e.target.value)} placeholder="Enter username" />
          </div>
          <div className={styles.formGroup}>
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="Enter email address"
            />
          </div>
          <div className={styles.formGroup}>
            <label>Gender</label>
            <select value={gender} onChange={e => setGender(e.target.value)}>
              <option value="">Select gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
            </select>
          </div>
          <div className={styles.formGroup}>
            <label>Bio</label>
            <input value={bio} onChange={e => setBio(e.target.value)} placeholder="Write something about yourself" />
          </div>

          <button
            className={`${styles.saveButton}`}
            onClick={handleSave}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Changes"}
          </button>
        </div>

        <MessagePopup
          isOpen={isPopupOpen}
          message={popupMessage}
          onClose={() => setIsPopupOpen(false)}
        />
      </div>

      
    </div>
  );
};

export default EditProfile;